import React, { useContext } from 'react';

import { SvgExCircle } from 'components/SvgIcon';

import {
  actionTypes,
  UserDrawerContext,
} from '../../../../UserDrawerContent/UserDrawerContext';

export const RemoveLicense = ({ license }) => {
  const {
    userDrawerState: { assignedLicenses, licensesToAdd },
    dispatchUserDrawer: dispatch,
  } = useContext(UserDrawerContext);

  const toggleRemoveLicense = () => {
    dispatch({
      type: actionTypes.SET_LICENSES_TO_ADD,
      licensesToAdd: licensesToAdd.filter((l) => l.id !== license.id),
    });
    dispatch({
      type: actionTypes.SET_ASSIGNED_LICENSES,
      assignedLicenses: assignedLicenses.filter((l) => l.id !== license.id),
    });
    dispatch({
      type: actionTypes.REMOVE_LICENSE,
      license,
    });
  };

  return (
    <>
      <button
        id={license.id}
        type="button"
        className="m-user-edit-drawer-section__remove"
        onClick={toggleRemoveLicense}
        data-testid="PlatformAdminUI-UsersLink-RemoveLicense-RemoveButton"
      >
        <SvgExCircle />
        <span
          className="Body m-user-edit-drawer-section__remove__text"
          data-testid="PlatformAdminUI-UsersLink-RemoveLicense-RemoveText"
        >
          Remove
        </span>
      </button>
    </>
  );
};
